function cov_abz0cxkd9() {
  var path = "/app/src/components/snippet-default/components/skeleton/index.ts";
  var hash = "43adb1f369be396e8686b1811cdb358a65bd95bb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/snippet-default/components/skeleton/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "43adb1f369be396e8686b1811cdb358a65bd95bb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_abz0cxkd9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_abz0cxkd9();
export { Skeleton } from './skeleton';